var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-blueGray-100 rounded h-full py-2 px-3"},[(_vm.item.custom_data.type == 'check' && _vm.item.pass)?_c('i',{staticClass:"fas fa-check-circle text-teal-700"}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }